import { PanelType } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { EUIPanel } from '../EUI/EUIPanel';
import { DetailsListAlarme } from '../List/DetailsListAlarme';

export class FicheAlarmes extends Component {

    static defaultProps = {
        afficherAlarmesInactives: true,
        afficherAlarmesLieesACapsules: false,
        afficherAlarmesLieesADemandes: false,
        afficherAlarmesLieesASouhaits: false,
        idContact: undefined, // id du contact (et de la capsule) pour lesquels afficher les alarmes
        idDemande: undefined, // id de la demande pour laquelle afficher les alarmes
        idSouhait: undefined, // id du souhait pour lequel afficher les alarmes
        idOperation: undefined,
        idReservation: undefined,
        isOpen: false,
        onDismiss: () => null
    };

    render = () => {

        const { afficherAlarmesLieesACapsules, afficherAlarmesLieesASouhaits, afficherAlarmesLieesADemandes } = this.props;
        const { idOperation, idReservation, idContact, idSouhait, idDemande, isOpen, onDismiss } = this.props;

        const getHeaderText = () => {
            if (!!idDemande) return "Alarmes rattachées à cette demande";
            if (!!idSouhait) return "Alarmes rattachées à ce souhait";
            if (!!idContact) return "Alarmes rattachées à cet espace client"; //2378
            return "Alarmes";
        };

        return <EUIPanel
            headerText={getHeaderText()}
            isOpen={isOpen}
            onDismiss={onDismiss}
            styles={{ content: { height: "100%" } }}
            type={PanelType.large}
        >
            <DetailsListAlarme
                activerFiltres={false}
                afficherAlarmesInactives={this.props.aefgfd}
                afficherAlarmesLieesACapsules={afficherAlarmesLieesACapsules}
                afficherAlarmesLieesADemandes={afficherAlarmesLieesADemandes}
                afficherAlarmesLieesASouhaits={afficherAlarmesLieesASouhaits}
                idContact={idContact}
                idDemande={idDemande}
                idOperation={idOperation}
                idReservation={idReservation}
                idSouhait={idSouhait}
            />
        </EUIPanel>;

    };

};